import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Alert as BlueprintAlert } from '@buildoutinc/blueprint-react/ui/Alert';

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface Props extends React.ComponentPropsWithoutRef<typeof BlueprintAlert> {
  icon?: IconDefinition;
}

export const Alert = Object.assign(
  React.forwardRef<HTMLDivElement, Props>(function Alert({ children, icon, ...props }, ref) {
    return (
      <BlueprintAlert {...props} ref={ref} withIcon={icon ? true : undefined}>
        {icon && <FontAwesomeIcon icon={icon} />}
        {children}
      </BlueprintAlert>
    );
  }),
  { Title: BlueprintAlert.Title },
);
